<template>
  <div>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-8"></div>
              <div class="col-sm-4">
                <div class="text-sm-right mb-2">
                  <button
                    @click="
                      $router.push({
                        name: 'product-catalogs_detail',
                        params: { id: 'new' },
                      })
                    "
                    type="button"
                    class="btn btn-warning"
                  >
                    <i
                      class="bx bx-edit-alt font-size-16 align-middle mr-2"
                    />Edit Product Catalog
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-row form-group">
                  <label class="col-md-2 col-form-label">ค้นหา</label>
                  <div class="col-md-8">
                    <input
                      v-model="filter.catalog"
                      type="text"
                      placeholder="ชื่อ Catalog"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-row form-group">
                  <label class="col-md-2 col-form-label">ประเภท</label>
                  <div class="col-md-5">
                    <catalogtype-selector
                      :reload="filter.reload"
                      :defaultValue="{
                        text: filter.typeName,
                        value: filter.typeId,
                      }"
                      @selected="onCatalogSelector($event)"
                    >
                    </catalogtype-selector>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-6">
                <div class="form-row form-group">
                  <label class="col-md-3 col-form-label">วันที่ Catalog</label>
                  <div class="col-md-8">
                    <date-range
                      @selected="onSelectedDate($event)"
                      :default="defaultDate"
                      id="dateRange"
                    ></date-range>
                  </div>
                </div>
              </div> -->
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-row form-group">
                  <label class="col-md-2 col-form-label">สินค้า</label>
                  <div class="col-md-8">
                    <input
                      v-model="filter.product"
                      type="text"
                      placeholder="รหัสกลุ่มสินค้า / รหัสสินค้า"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-row form-group">
                  <label class="col-md-2 col-form-label">สถานะ</label>
                  <div class="col-md-6">
                    <div class="col-form-label row" style="margin-left: 0px">
                      <!-- {{filter.statusText}} -
                      {{filter.statusValue}} -->
                      <status-catalog-selector
                        ref="refStatusCatalogSelector"
                        :reload="filter.reloadStatus"
                        :defaultValue="filter.status"
                        @selected="onStatusSelector($event)"
                      >
                      </status-catalog-selector>
                      <!-- <b-form-checkbox
                        @change="onSelectAll($event)"
                        class="custom-checkbox-info mb-3"
                        style="margin-right: 10px"
                        name="all"
                        id="all"
                        v-model="selectAll"
                        >เลือกทั้งหมด</b-form-checkbox
                      >
                      <div
                        v-for="(data_status, index) in selectAllStatus"
                        :key="index"
                      >
                        <b-form-checkbox
                          v-model="filter.status"
                          :value="data_status"
                          class="custom-checkbox-info mb-3"
                          style="margin-right: 10px"
                          :name="data_status.toLowerCase()"
                          :id="data_status.toLowerCase()"
                          >{{ data_status }}
                        </b-form-checkbox>
                      </div> -->
                      <!-- <b-form-checkbox
                        v-model="filter.status"
                        value="Active"
                        class="custom-checkbox-success mb-3"
                        style="margin-right: 10px"
                        name="active"
                        id="active"
                        >Active</b-form-checkbox
                      >
                      <b-form-checkbox
                        v-model="filter.status"
                        value="Inactive"
                        class="custom-checkbox-warning mb-3"
                        style="margin-right: 10px"
                        name="inactive"
                        id="inactive"
                        >Inactive</b-form-checkbox
                      >
                      <b-form-checkbox
                        v-model="filter.status"
                        value="Delete"
                        class="custom-checkbox-danger mb-3"
                        style="margin-right: 10px"
                        name="delete"
                        id="delete"
                        >Delete</b-form-checkbox
                      > -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-12">
                <div class="form-row form-group">
                  <label class="col-md-1 col-form-label">สถานะ</label>
                  <div class="col-form-label row" style="margin-left: 0px">
                    <b-form-checkbox
                      @change="onSelectAll($event)"
                      class="custom-checkbox-info mb-3"
                      style="margin-right: 10px"
                      name="all"
                      id="all"
                      v-model="selectAll"
                      >เลือกทั้งหมด</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="filter.status"
                      value="Active"
                      class="custom-checkbox-info mb-3"
                      style="margin-right: 10px"
                      name="active"
                      id="active"
                      >Active</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="filter.status"
                      value="Inactive"
                      class="custom-checkbox-info mb-3"
                      style="margin-right: 10px"
                      name="inactive"
                      id="inactive"
                      >Inactive</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="filter.status"
                      value="Delete"
                      class="custom-checkbox-info mb-3"
                      style="margin-right: 10px"
                      name="delete"
                      id="delete"
                      >Delete</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="filter.status"
                      value="Expire"
                      class="custom-checkbox-info mb-3"
                      style="margin-right: 10px"
                      name="expire"
                      id="expire"
                      >Expire</b-form-checkbox
                    >
                  </div>
                </div>
              </div>
            </div> -->
            <div class="row">
              <div class="col-lg-12 text-sm-right">
                <div class="button-items">
                  <button
                    type="button"
                    class="btn btn-primary waves-effect"
                    @click="onFilter()"
                  >
                    <i class="bx bx-search font-size-16 align-middle mr-2"></i>
                    Search
                  </button>
                  <button
                    type="button"
                    class="btn btn-light waves-effect"
                    @click="onReset()"
                  >
                    <i class="bx bx-reset font-size-16 align-middle mr-2"></i>
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-if="showDataTable">
          <div class="card-body">
            <div class="row form-group">
              <div class="col-sm-12 col-md-9">
                <div id="tickets-table_length" class="dataTables_length">
                  <span>จำนวน</span>
                  <label class="d-inline-flex align-items-center">
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      @change="onFilter()"
                      class="ml-3"
                    ></b-form-select>
                  </label>
                  <span class="ml-2"
                    >จากทั้งหมด {{ totalRecords | number }} รายการ</span
                  >
                </div>
              </div>
              <div class="col-sm-12 col-md-3">
                <div class="input-group md-form form-sm text-right">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <span class="bx bx-search-alt"></span>
                    </span>
                  </div>
                  <input
                    v-model="search"
                    class="form-control my-0 py-1"
                    type="search"
                    placeholder="ค้นหา"
                    aria-label="Search"
                  />
                </div>
                <!-- <div class="input-group md-form form-sm text-md-right">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <span class="bx bx-search-alt"></span>
                    </span>
                  </div>
                  <input
                    v-model="search"
                    class="form-control my-0 py-1"
                    type="search"
                    placeholder="ค้นหา"
                    aria-label="Search"
                  />
                  <div class="button-items ml-1">
                   <b-dropdown
                    class="btn-export"
                    text="Export"
                    variant="secondary"
                  >
                    <template slot="button-content"
                      ><i class="bx bx bx-file"/>Export<i
                        class="mdi mdi-chevron-down"
                      ></i
                    ></template>
                    <b-dropdown-item @click="onExportExcel()"
                      ><i class="far fa-file-excel text-success" />Excel
                    </b-dropdown-item>
                  </b-dropdown>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <b-table
                    class="table table-centered table-nowrap"
                    ref="productCatalogtable"
                    :empty-text="'ไม่พบข้อมูล'"
                    :show-empty="
                      items === null ||
                        items === undefined ||
                        (items && items.length === 0)
                    "
                    :bordered="true"
                    :filter="search"
                    :items="items"
                    align="center"
                    v-bind:fields="fields"
                    @filtered="onFiltered"
                    :perPage="perPage"
                  >
                    <template v-slot:cell(index)="data">
                      <div class="text-right">
                        {{ (firstRowOnPage + data.index) | number }}
                      </div>
                    </template>
                    <template v-slot:cell(catalog_status)="data">
                      <span
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>
                    <template v-slot:cell(inventory_status)="data">
                      <span
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>
                    <template v-slot:cell(sale_status)="data">
                      <span
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <div class="text-center">
                        <a
                          @click="
                            $router.push({
                              name: 'product-catalogs_detail',
                              params: { id: data.item.id },
                            })
                          "
                          class="btn btn-ico text-info"
                          title="View"
                          ><i class="bx bx-show"></i
                        ></a>
                        <a
                          @click="
                            $router.push({
                              name: 'product-catalogs_detail',
                              params: { id: data.item.id },
                              query: { mode: 'edit' },
                            })
                          "
                          class="btn btn-ico text-warning"
                          title="Edit"
                          ><i class="bx bx-edit-alt"></i
                        ></a>
                        <!-- <a
                          @click="
                            onConfirmDelete(
                              data.item.id,
                              data.item.display_name
                            )
                          "
                          class="btn btn-ico text-danger"
                          ><i class="bx bx-trash"></i
                        ></a> -->
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
            <div class="row" v-if="items.length > 0">
              <div class="col-lg-4">
                <div style="position: relative; top: 7px">
                  รายการที่ {{ firstRowOnPage | number }} -
                  {{ lastRowOnPage | number }} จากทั้งหมด
                  {{ totalRecords | number }} รายการ
                </div>
              </div>
              <div class="col-lg-8">
                <b-pagination
                  :total-rows="totalRecords"
                  :per-page="perPage"
                  v-model="pageNo"
                  @change="onClickPagination($event)"
                  class="pagination pagination-rounded justify-content-end mb-2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import { FormatDate, FormatDateTime } from '@/helpers/utils/format-date.js'
import dateRange from '@/components/share/date-range.vue'
import productCatalogService from '@/helpers/service/product-catalog-service'

import PageHeader from '@/components/page-header'
import { StatusEnum } from '@/enum/status.enum.js'
import appConfig from '@/app.config'
import { eventBus } from '@/main.js'
import { productCatalogComputed, productCatalogMethods } from '@/state/helpers'
import CatalogTypeSelector from '@/components/catalogtypes/selector'
import StatusCatalogSelector from '@/components/catalog/status-selector'
// import { OptionCheckboxStatus } from '@/helpers/utils/status.js'

export default {
  name: 'product-catalog',
  page: {
    title: 'Product Catalog',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    PageHeader,
    // 'date-range': dateRange,
    'catalogtype-selector': CatalogTypeSelector,
    'status-catalog-selector': StatusCatalogSelector
  },
  data() {
    return {
      search: null,
      title: 'Product Catalog',
      itemsPageHeader: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Product Catalog',
          active: true,
        },
      ],
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'catalog_type.display_name.en',
          label: 'ประเภท Catelog',
          sortable: true,
        },
        {
          key: 'catalog_display_name.th',
          label: 'ชื่อ Catalog (ไทย)',
          sortable: true,
        },
        {
          key: 'catalog_display_name.en',
          label: 'ชื่อ Catalog (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'catalog_start_date',
          label: 'วันที่เริ่มต้น',
          formatter: (value, key, item) => {
            return FormatDate(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'catalog_end_date',
          label: 'วันที่สิ้นสุด',
          formatter: (value, key, item) => {
            return FormatDate(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        // {
        //   key: 'catalog_status',
        //   label: 'สถานะ Catalog',
        //   thStyle: 'width:120px',
        //   sortable: true,
        //   tdClass: 'text-center',
        // },
        {
          key: 'product_id',
          label: 'รหัสกลุ่มสินค้า',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sku_code_ofm',
          label: 'รหัสสินค้า (OFM)',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'product_display_name.th',
          label: 'ชื่อสินค้า',
          sortable: true,
        },
        {
          key: 'inventory_status',
          label: 'สถานะสินค้า',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sale_status',
          label: 'สถานะการขาย',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'pages',
          formatter: (value, key, item) => {
            return FormatQty(value && value !== '' ? value : 0)
          },
          label: 'เลขหน้า',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'remark',
          label: 'หมายเหตุเพิ่มเติม',
          sortable: true,
        },
        // {
        //   key: 'action',
        //   label: 'Action',
        //   thStyle: 'width:80px',
        // },
      ],
      listModel: {
        type: Object,
        default: () => {
          return {
            firstRowOnPage: 0,
            items: [],
            lastRowOnPage: 0,
            pageNo: 1,
            totalPages: 0,
            totalRecords: 0,
            pageSize: 10,
            prevPage: 0,
            nextPage: 0,
          }
        },
      },
      defaultDate: [],
      items: [],
      pageNo: 1,
      totalPages: 0,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
      totalRecords: 0,
      perPage: 10,
      filter: {
        catalog: '',
        product: '',
        typeId: '',
        typeName: '',
        reload: false,
        catalogStartDate: '',
        catalogEndDate: '',
        status: [],
        reloadStatus: false,
        isStatus: {
          all: false,
          active: false,
          inactive: false,
          expire: false,
          delete: false,
        },
      },
      selectAll: false,
      selectAllStatus: [],
      // selectAllStatus: [
      //   StatusEnum.ACTIVE,
      //   StatusEnum.INACTIVE,
      //   StatusEnum.DELETE,
      //   StatusEnum.EXPIRE,
      // ],
      pageOptions: [10, 25, 50, 100],
      showDataTable: false,
      typeListOption: [],
    }
  },
  computed: {
    ...productCatalogComputed,
  },
  mounted() {
    // this.selectAllStatus = OptionCheckboxStatus
    this.filter = Object.assign({}, this.GET_FILTER_PRODUCT_CATALOG)
    this.defaultDate = [
      new Date(this.filter.catalogStartDate),
      new Date(this.filter.catalogEndDate),
    ]
    if (this.filter.isFilter) {
      this.onFilter()
    }
  },
  watch: {
    // 'filter.status': {
    //   handler() {
    //     this.selectAll =
    //       this.filter.status.length === this.selectAllStatus.length
    //         ? true
    //         : false
    //   },
    //   deep: true,
    // },
    GET_FILTER_PRODUCT_CATALOG(val, oldVal) {
      console.log('GET_FILTER_PRODUCT_CATALOG', val)
      this.filter = Object.assign({}, val)
    },
    listModel: function(value) {
      this.totalPages = value.totalPages
      this.firstRowOnPage = (value.pageNo - 1) * value.pageSize + 1
      this.lastRowOnPage =
        value.pageSize <= 0
          ? value.totalRecords
          : Math.min(value.pageNo * value.pageSize, value.totalRecords)
      this.totalRecords = value.totalRecords

      if (this.showDataTable) {
        this.$refs.productCatalogtable.localSortBy = ''
      }
      this.items = value.items
      this.perPage = value.pageSize
      this.pageNo = value.pageNo
    },
  },
  methods: {
    ...productCatalogMethods,
    // onSelectAll(event) {
    //   this.filter.status = event ? this.selectAllStatus : []
    // },
    async onFiltered(filteredItems) {
      this.totalPages = filteredItems.length
    },
    async onClickPagination(pageNo) {
      this.search = ''
      let params = new URLSearchParams()
      params.append('pageSize', this.perPage)
      params.append('pageNo', pageNo)
      params.append('catalog', this.filter.catalog.trim() || '')
      params.append('product', this.filter.product.trim() || '')
      params.append('catalogType', this.filter.typeId || '')
      params.append('catalogStartDate', this.filter.catalogStartDate || '')
      params.append('catalogEndDate', this.filter.catalogEndDate || '')
      params.append('sort', '-catalog_start_date')
      this.filter.status.forEach(element => {
        params.append('status', element.value)
      })
      let result = await productCatalogService.getProductCatalogListAsync(
        params
      )
      if (result.status === 200) {
        this.listModel = result.data
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log('error', result.response.data.message)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onFilter() {
      this.showDataTable = true
      let params = new URLSearchParams()
      params.append('pageSize', this.perPage)
      params.append('catalog', this.filter.catalog.trim() || '')
      params.append('product', this.filter.product.trim() || '')
      params.append('catalogType', this.filter.typeId || '')
      params.append('catalogStartDate', this.filter.catalogStartDate || '')
      params.append('catalogEndDate', this.filter.catalogEndDate || '')
      params.append('sort', '-catalog_start_date')
      this.filter.status.forEach(element => {
        params.append('status', element.value)
      })
      let result = await productCatalogService.getProductCatalogListAsync(
        params
      )
      if (result.status === 200) {
        this.listModel = result.data
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log('error', result.response.data.message)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
      this.ADD_FILTER_PRODUCT_CATALOG(this.filter)
    },
    onReset() {
      this.listModel = {
        firstRowOnPage: 0,
        items: [],
        lastRowOnPage: 0,
        pageNo: 1,
        totalPages: 0,
        totalRecords: 0,
        pageSize: 10,
        prevPage: 0,
        nextPage: 0,
      }
      this.defaultDate = []
      this.$refs.refStatusCatalogSelector.reset()
      this.CLEAR_FILTER_PRODUCT_CATALOG()
    },
    // async onConfirmDelete(id, name) {
    //   await this.$utils
    //     .confirmAlertDisplay(
    //       `คุณต้องการเปลี่ยนสถานะข้อมูล ${name} เป็น Delete ใช่หรือไม่`,
    //       ''
    //     )
    //     .then(result => {
    //       if (result) {
    //         this.onDelete(id)
    //       }
    //     })
    // },
    // async onDelete(id) {
    //   let result = await catalogService.deleteCatalogMasterByIdAsync(id)
    //   if (result.status && result.status === 204) {
    //     this.$utils.notification(
    //       'success',
    //       'เปลี่ยนข้อมูลเป็นสถานะ Delete สำเร็จ',
    //       1500
    //     )
    //     this.onFilter()
    //   } else {
    //     this.$utils.notification('error', result.response.data.message, 2000)
    //   }
    // },

    async onSelectedDate(value) {
      this.filter.catalogStartDate = value.from
      this.filter.catalogEndDate = value.to
      // if (this.filter.catalogStartDate !== "" && this.filter.catalogEndDate !== "") {
      //   document.getElementById("dateRange").classList.remove("error");
      // }
    },
    async onCatalogSelector(data) {
      this.filter.reload = false
      this.filter.typeId = data.value
      this.filter.typeName = data.text
    },
    async onStatusSelector(data) {
      this.filter.reloadStatus = false
      // console.log('onStatusSelector', data)
      this.filter.status = data
    },
  },
}
</script>
<style></style>
